import React from 'react';
import { Box, Checkbox } from 'edenred-ui';
import { Trans } from 'react-i18next';

import { StyledSelectBenefitCard } from './BenefitTypeCard.styles';
import { useFormContext } from 'react-hook-form';
import {
  IBenefits,
  ICreateBenefitGroupForm
} from '@epi-models/pages/BenefitGroups';
import { BenefitTypeIcon } from '../BenefitTypeIcon/BenefitTypeIcon';

interface BenefitTypeCardProps {
  benefitType: IBenefits;
  maxAmount: number;
}

export const BenefitTypeCard = ({
  benefitType,
  maxAmount
}: BenefitTypeCardProps) => {
  const { watch, setValue, formState, trigger } =
    useFormContext<ICreateBenefitGroupForm>();

  const value = watch(`benefitSettings.${benefitType}`);

  const handleToggleCheckbox = () => {
    if (value) {
      setValue(`benefitSettings.${benefitType}`, undefined, {
        shouldDirty: true,
        shouldValidate: true
      });
    } else {
      const defaultValue =
        formState.defaultValues?.benefitSettings?.[benefitType];
      setValue(
        `benefitSettings.${benefitType}`,
        defaultValue || { maxAmountPerPeriod: maxAmount },
        { shouldDirty: true, shouldValidate: true }
      );
    }
    trigger();
  };

  return (
    <StyledSelectBenefitCard
      isSelected={!!value}
      onClick={handleToggleCheckbox}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Box
          width={32}
          height={32}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <BenefitTypeIcon benefit={benefitType?.toLowerCase()} />
        </Box>
        <Trans i18nKey={`containers.benefit_groups.benefits.${benefitType}`} />
      </Box>
      <Box>
        <Checkbox checked={!!value} />
      </Box>
    </StyledSelectBenefitCard>
  );
};
